import { render, staticRenderFns } from "./lor-facets-metadata-card.vue?vue&type=template&id=f57dbd1e&scoped=true&"
import script from "./lor-facets-metadata-card.ts?vue&type=script&lang=ts&"
export * from "./lor-facets-metadata-card.ts?vue&type=script&lang=ts&"
import style0 from "./lor-facets-metadata-card.scss?vue&type=style&index=0&id=f57dbd1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57dbd1e",
  null
  
)

export default component.exports